/* KBW Sink grid.
 *
 * Custom script: not part of the Maximize theme, so a theme update will
 * never overwrite it.
 *
 * Every card is already in the page, printed server-side. This only hides
 * the ones a filter has ruled out -- no fetch, no re-render, so a crawler
 * and a no-JS visitor both see the full range regardless.
 *
 * Three fixed groups: room, mount, material. Within a group the ticked
 * values are alternatives; across groups every group must agree, same as
 * kbw-flooring-grid.js.
 *
 * One thing flooring's script does not do: Room and Material move together
 * in this data (every Bathroom sink is Ceramic today). Once that leaves a
 * group with exactly one live value and nothing in it ticked, its checkbox
 * list is swapped for a stated-fact line -- a tickbox nobody can turn off
 * teaches nothing. The group comes back the moment the selection changes
 * again.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-kbw-sk]').forEach(initSinkGrid);

  function initSinkGrid(root) {
    var grid = root.querySelector('[data-kbw-sk-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-sk-card]'));
    var checkboxes = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-sk-filter]'));
    var countEl = root.querySelector('[data-kbw-sk-count]');
    var emptyEl = root.querySelector('[data-kbw-sk-empty]');
    var emptyHeading = root.querySelector('[data-kbw-sk-empty-heading]');
    var emptyText = root.querySelector('[data-kbw-sk-empty-text]');
    var emptyActs = root.querySelector('[data-kbw-sk-empty-acts]');
    var resetBtn = root.querySelector('[data-kbw-sk-reset]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-kbw-sk-group]'));

    if (!grid || !cards.length) return;

    var fallbackHeading = emptyHeading ? emptyHeading.textContent : 'No sink matches these filters';
    var fallbackText = emptyText ? emptyText.textContent : '';

    function facetOf(cb) {
      return cb.getAttribute('data-group') || 'room';
    }

    function cardValue(card, facet) {
      return card.getAttribute('data-' + facet) || '';
    }

    function selections() {
      var out = {};
      checkboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var facet = facetOf(cb);
        (out[facet] = out[facet] || []).push(cb.value);
      });
      return out;
    }

    function passes(card, sel, skipFacet) {
      return Object.keys(sel).every(function (facet) {
        if (facet === skipFacet) return true;
        return sel[facet].indexOf(cardValue(card, facet)) !== -1;
      });
    }

    function labelFor(facet, sel) {
      if (facet === 'room') return sel.room && sel.room[0] ? sel.room[0] + ' sink' : '';
      if (facet === 'mount') return sel.mount && sel.mount[0] ? sel.mount[0] : '';
      if (facet === 'material') return sel.material && sel.material[0] ? sel.material[0] : '';
      return '';
    }

    /* --- collapse a group to a stated fact when only one live value is left --- */

    function updateGroupCollapse(group, sel) {
      var facet = group.getAttribute('data-kbw-sk-group');
      var options = Array.prototype.slice.call(group.querySelectorAll('[data-kbw-sk-filter]'));
      var ownTicked = (sel[facet] || []).length > 0;
      var fact = group.querySelector('[data-kbw-sk-fact]');

      if (ownTicked) {
        group.classList.remove('is-collapsed');
        if (fact) fact.hidden = true;
        return null;
      }

      var live = [];
      options.forEach(function (cb) {
        var n = 0;
        cards.forEach(function (card) {
          if (cardValue(card, facet) === cb.value && passes(card, sel, facet)) n += 1;
        });
        if (n > 0) live.push(cb.value);
      });

      if (live.length === 1) {
        group.classList.add('is-collapsed');
        if (fact) {
          var valueEl = fact.querySelector('[data-kbw-sk-fact-value]');
          if (valueEl) valueEl.textContent = live[0];
          fact.hidden = false;
        }
        return live[0];
      }

      group.classList.remove('is-collapsed');
      if (fact) fact.hidden = true;
      return null;
    }

    /* --- the empty state: a sentence built from what is ticked, two exits --- */

    function renderEmpty(sel) {
      if (!emptyEl) return;
      var active = Object.keys(sel).filter(function (f) { return sel[f].length > 0; });

      if (active.length >= 2 && emptyText) {
        // Build "No {room} sink is a {mount} sink." style sentence from
        // whichever two groups are actually ticked, in a fixed, readable
        // order -- never a hard-coded pair, so it is right for any 0-result
        // combination this data ever produces.
        var order = ['room', 'mount', 'material'];
        var picked = order.filter(function (f) { return active.indexOf(f) !== -1; });
        if (picked.length >= 2) {
          var a = sel[picked[0]][0];
          var b = sel[picked[1]][0];
          if (emptyHeading) emptyHeading.textContent = fallbackHeading;
          emptyText.textContent = 'No ' + a.toLowerCase() + ' sink is a ' + b.toLowerCase() + ' sink. Drop one of the ticked filters to carry on.';
        } else if (emptyHeading) {
          emptyHeading.textContent = fallbackHeading;
          emptyText.textContent = fallbackText;
        }
      } else if (emptyHeading) {
        emptyHeading.textContent = fallbackHeading;
        if (emptyText) emptyText.textContent = fallbackText;
      }

      if (!emptyActs) return;
      emptyActs.innerHTML = '';
      // One exit per active group: drop that group, keep the rest.
      active.forEach(function (facet) {
        var others = {};
        Object.keys(sel).forEach(function (f) { if (f !== facet) others[f] = sel[f]; });
        var n = cards.filter(function (card) { return passes(card, others, null); }).length;
        if (n === 0) return;
        var label = active.length > 1
          ? 'See the ' + n + ' ' + active.filter(function (f) { return f !== facet; }).map(function (f) { return sel[f][0]; }).join(' ').toLowerCase() + ' sink' + (n === 1 ? '' : 's')
          : 'See all ' + n + ' sinks';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kbw-sk-empty__btn' + (emptyActs.children.length > 0 ? ' kbw-sk-empty__btn--ghost' : '');
        btn.textContent = label;
        btn.addEventListener('click', function () {
          checkboxes.forEach(function (cb) { if (facetOf(cb) === facet) cb.checked = false; });
          applyFilter();
        });
        emptyActs.appendChild(btn);
      });
      if (emptyActs.children.length === 0) {
        var resetAllBtn = document.createElement('button');
        resetAllBtn.type = 'button';
        resetAllBtn.className = 'kbw-sk-empty__btn';
        resetAllBtn.textContent = 'See all ' + cards.length + ' sinks';
        resetAllBtn.addEventListener('click', function () {
          checkboxes.forEach(function (cb) { cb.checked = false; });
          applyFilter();
        });
        emptyActs.appendChild(resetAllBtn);
      }
    }

    function applyFilter() {
      var sel = selections();
      var anyTicked = Object.keys(sel).length > 0;
      var visible = 0;

      cards.forEach(function (card) {
        var show = passes(card, sel, null);
        card.hidden = !show;
        if (show) visible += 1;
      });

      checkboxes.forEach(function (cb) {
        var facet = facetOf(cb);
        var n = 0;
        cards.forEach(function (card) {
          if (cardValue(card, facet) === cb.value && passes(card, sel, facet)) n += 1;
        });
        var opt = cb.closest ? cb.closest('.kbw-rail__check') : null;
        var optCount = opt ? opt.querySelector('[data-kbw-sk-optcount]') : null;
        if (optCount) optCount.textContent = n;
        var dead = n === 0 && !cb.checked;
        cb.disabled = dead;
        if (opt) opt.classList.toggle('is-empty', dead);
      });

      groups.forEach(function (group) { updateGroupCollapse(group, sel); });

      if (countEl) countEl.innerHTML = '<b>' + visible + '</b> ' + (visible === 1 ? 'sink' : 'sinks');
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (visible === 0) renderEmpty(sel);
      if (resetBtn) resetBtn.hidden = !anyTicked;
      if (window.KbwRail) window.KbwRail.refresh(root);
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', applyFilter);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        checkboxes.forEach(function (cb) { cb.checked = false; });
        applyFilter();
      });
    }

    // A room or mount pre-selected from the URL -- the hero's "start with
    // the mount" cards and the mega-menu tiles both link here this way.
    try {
      var params = new URLSearchParams(window.location.search);
      ['room', 'mount', 'material'].forEach(function (facet) {
        var wanted = params.get(facet);
        if (!wanted) return;
        checkboxes.forEach(function (cb) {
          if (facetOf(cb) === facet && cb.value === wanted) cb.checked = true;
        });
      });
    } catch (e) {
      /* URLSearchParams missing or malformed query string -- leave everything showing */
    }

    applyFilter();
  }
})();
